import classNames from "classnames";
import Image from "next/image";
import styles from "./PreviewFinalResultButton.module.css";

interface PreviewFinalResultButtonProps {
  thumbnails: string[];
  onClick?: () => void;
}

const thumbnailLayouts = [
  { offset: 0, rotation: 4, zIndex: 10 },
  { offset: 14, rotation: 3, zIndex: 20 },
  { offset: 28, rotation: 5, zIndex: 30 },
] as const;

export function PreviewFinalResultButton({
  thumbnails,
  onClick,
}: PreviewFinalResultButtonProps) {
  const previewImages = thumbnails.filter(Boolean).slice(0, 3);

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        styles.gradientBorder,
        "group relative flex h-12 items-center overflow-hidden",
        "rounded-full",
        "p-2 pl-5 shadow-[0_14px_28px_rgba(0,0,0,0.35)] transition-all duration-200 hover:border hover:border-[#292c59] cursor-pointer",
        "text-black/80 hover:text-[#c0c4fa]"
      )}
    >
      <span className="text-base font-medium leading-[20px] ">
        Preview the final result
      </span>

      <div className="relative w-[58px] ml-2 flex h-10 shrink-0 items-center">
        {thumbnailLayouts.map(({ offset, rotation, zIndex }, index) => {
          const src = previewImages[index];
          return (
            <div
              key={offset}
              style={{
                left: `${offset}px`,
                transform: `rotate(${rotation}deg)`,
                zIndex,
              }}
              className={classNames(
                "absolute size-9 overflow-hidden rounded-md border-2 border-white",
                "bg-[#26263c] shadow-[0_6px_12px_rgba(0,0,0,0.32)]"
              )}
            >
              {src ? (
                <Image
                  src={src}
                  alt="Storyboard preview"
                  fill
                  className="object-cover"
                  sizes="36px"
                  unoptimized
                />
              ) : null}
            </div>
          );
        })}
      </div>

      <div className="ml-5 flex size-9 items-center justify-center rounded-full bg-primary text-[#1a1a2b] shadow-[0_10px_20px_rgba(0,0,0,0.32)] group-hover:bg-[#b4b0ff] group-hover:text-text-primary">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M9.82373 16.4762H21.2943"
            stroke="#E5E5FF"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M17.4707 11.4762L21.7971 16.073C22.0103 16.2995 22.0103 16.6529 21.7971 16.8794L17.4707 21.4762"
            stroke="#E5E5FF"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </button>
  );
}
